export default "__VITE_ASSET__33e646aa__"